import React from 'react';
import dynamic from '../../Image/dynamic.webp';
import mobile from '../../Image/mobile.jpeg';
import risk from '../../Image/risk.jpg';
import technology from '../../Image/TECHNOLOGY.jpg';
import './Why.css';

const Why = () => {
  return (
    <div id="Why" className="why-section">
      <div className="container">
        <h1 className="text-center headingThree">WHY Xeven Maintenance LLC</h1>
        <div className="separator-line"></div>

        {/* Dynamic Leadership */}
        <div className="row content-box">
          <div className="col-md-6 text-content">
            <h2 className="headingThree">DYNAMIC LEADERSHIP</h2>
            <div className="separator-line"></div>
            <p>
              We at Xeven Maintenance LLC understand the importance of a well-structured organization with clear lines of management from top to bottom. Our company is therefore structured in a way that customers come first, with complaints being swiftly handled. Additionally, we take into consideration customers’ feedback and opinions before implementing any new idea with the focus on building long-term relationships based on trust and integrity.
              Our strong management team combines experience and leadership to attract and retain the best staff in the industry—staff who complete even the most ambitious preservation practices with excellence.
            </p>
          </div>
          <div className="col-md-6 image-content">
            <img className="feature-image" src={dynamic} alt="Dynamic Leadership" />
          </div>
        </div>

        {/* Mobile Integration */}
        <div className="row content-box reverse">
          <div className="col-md-6 image-content">
            <img className="feature-image" src={mobile} alt="Mobile Integration" />
          </div>
          <div className="col-md-6 text-content">
            <h2 className="headingThree">MOBILE INTEGRATION</h2>
            <div className="separator-line"></div>
            <p>
              Our IT team is at the forefront of mobile innovation. We’ve developed a mobile application that ensures you're aware of activities at your property in real time. It lets you see who visited and when, with instant photo and time-stamped updates. This transparency allows you to make decisions quickly while staying fully informed.
            </p>
          </div>
        </div>

        {/* Risk Management */}
        <div className="row content-box">
          <div className="col-md-6 text-content">
            <h2 className="headingThree">RISK MANAGEMENT</h2>
            <div className="separator-line"></div>
            <p>
              At Xeven Maintenance LLC, we know how much you value your property. That’s why we maintain full insurance coverage and approach preservation with professionalism. We mitigate reputational and financial risks through ongoing maintenance, data-driven risk analysis, and robust management practices designed to protect your assets.
            </p>
          </div>
          <div className="col-md-6 image-content">
            <img className="feature-image" src={risk} alt="Risk Management" />
          </div>
        </div>

        {/* Technology */}
        <div className="row content-box reverse">
          <div className="col-md-6 image-content">
            <img className="feature-image" src={technology} alt="Technology" />
          </div>
          <div className="col-md-6 text-content">
            <h2 className="headingThree">TECHNOLOGY</h2>
            <div className="separator-line"></div>
            <p>
              In a dynamic industry where time and quality matter, we leverage cutting-edge software to manage assets and work orders. Our systems automate inspections, preservation, and reporting—ensuring speed, accuracy, and productivity. By integrating smartphones and high-speed internet, we deliver real-time updates and keep you informed every step of the way.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Why;
